import React from "react";
import { DiagramPageData } from "../types";
import { InfoCard } from "./InfoCard";

type LightingElectronicsProps = {
  pageData: DiagramPageData;
};

export const LightingElectronics = ({ pageData }: LightingElectronicsProps) => {
  const section = pageData.section;

  if (!section) {
    return null;
  }

  return (
    <InfoCard
      titleKey={section.titleKey}
      fields={section.fields}
      singleColumn
      fullWidth
      autoHeight
    />
  );
};
